import {Component} from '@angular/core';

/**
 * Outermost wrapper of a full-height management page — and the single owner of that page's gutter.
 *
 * It renders one absolutely positioned flex **column** that fills the nearest positioned ancestor (the app
 * shell's fixed content region, or the `app-edit-component-base` panel) and supplies the page gutter itself,
 * because an absolutely positioned box cannot see its containing block's padding. Children stack top-to-bottom:
 * a `layout-header-container`, any toolbars/filters, and finally a `layout-page-scrollable`, which claims the
 * leftover height and is the page's only scroll container.
 *
 * Nothing inside may add a second horizontal inset. See `docs/articles/frontend/page-layout-contract.md` for the
 * full contract and the reasoning behind it (#235).
 */
@Component({
  selector: 'layout-page-container',
  imports: [],
  templateUrl: './page-container.component.html',
  styleUrl: './page-container.component.scss'
})
export class PageContainerComponent {

}
